import constants from '../helpers/constants.js';
import initialState from './initialState.js';
import _ from 'lodash';





export default function notificationReducer(state = initialState.notification, action) {
    switch (action.type) {
        case constants.USER_NOTIFICATION_INIT:
            return Object.assign({}, state, { init: action.data });
        case constants.USER_NOTIFICATION_COUNT:
            return Object.assign({}, state, { count: action.data });
        case constants.WEB_SOCKET_CONNECTED:
            return Object.assign({}, state, { wsConnected: action.data });
        case constants.WEB_SOCKET_RECONNECTING:
            return Object.assign({}, state, { wsReconnecting: action.data });
        case constants.WEB_SOCKET_LATEST_NOTIFICATION:
            return Object.assign({}, state, { latestNotification: action.data }); 
        case constants.WEB_SOCKET_LATEST_NOTIFICATION_SHOW:
            return Object.assign({}, state, { latestNotificationShow: action.data });
        case constants.NOTIFICATION_SETTINGS:
            return Object.assign({}, state, { settings: action.data });
        default:
            return state;
    }
}